import React from "react";

const OverviewTab = ({ tenant }: { tenant: any }) => {
  if (!tenant) return null;

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold">Tenant Overview</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        
        <div className="p-4 border rounded-lg bg-gray-50">
          <p className="text-gray-500 text-sm">Tenant Name</p>
          <p className="text-lg font-medium">{tenant?.tenant?.name}</p>
        </div>

        <div className="p-4 border rounded-lg bg-gray-50">
          <p className="text-gray-500 text-sm">Slug</p>
          <p className="text-lg font-medium">{tenant?.tenant?.slug}</p>
        </div>

        <div className="p-4 border rounded-lg bg-gray-50">
          <p className="text-gray-500 text-sm">Users</p>
          <p className="text-lg font-medium">{tenant?.activeUsers}</p>
        </div>

        <div className="p-4 border rounded-lg bg-gray-50">
          <p className="text-gray-500 text-sm">Created At</p>
          <p className="text-lg font-medium">
            {new Date(tenant?.tenant?.createdAt).toLocaleString()}
          </p>
        </div>
      </div>
    </div>
  );
};

export default OverviewTab;
